const MicIconForLlm = ({ isRecording }) => {
  const basePath = `${window.location.origin}/images`;

  return (
    <img
      src={
        isRecording
          ? `${basePath}/mic-selected.png`
          : `${basePath}/mic-not-selected.png`
      }
      alt="Mic Icon"
      style={{ width: 25, height: 25, border : '2px solid white'}}
    />
  );
};

export default MicIconForLlm;
